import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const GoogleDataStudioIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M17.5015 14.2241H10.2391C8.48304 14.2241 7.49902 15.4537 7.49902 16.7617C7.49902 17.9689 8.33343 19.2993 10.2391 19.2993H17.5015V14.2241Z"
      fill="#669DF3"
    />
    <path
      d="M17.5014 19.2953C18.8813 19.2953 19.9999 18.1591 19.9999 16.7576C19.9999 15.3561 18.8813 14.22 17.5014 14.22C16.1215 14.22 15.0029 15.3561 15.0029 16.7576C15.0029 18.1591 16.1215 19.2953 17.5014 19.2953Z"
      fill="#1A73E8"
    />
    <path
      d="M10.0024 7.45776H2.74C0.984 7.45776 0 8.68736 0 9.99616C0 11.2034 0.8344 12.5338 2.74 12.5338H10.0024V7.45776Z"
      fill="#669DF3"
    />
    <path
      d="M10.0023 12.5337C11.3821 12.5337 12.5007 11.3976 12.5007 9.9961C12.5007 8.59462 11.3821 7.4585 10.0023 7.4585C8.62248 7.4585 7.50391 8.59462 7.50391 9.9961C7.50391 11.3976 8.62248 12.5337 10.0023 12.5337Z"
      fill="#1A73E8"
    />
    <path
      d="M17.5015 0.696045H10.2391C8.48304 0.696045 7.49902 1.92564 7.49902 3.23364C7.49902 4.44084 8.33343 5.77125 10.2391 5.77125H17.5015V0.696045Z"
      fill="#669DF3"
    />
    <path
      d="M17.5014 5.77125C18.8813 5.77125 19.9999 4.63512 19.9999 3.23364C19.9999 1.83217 18.8813 0.696045 17.5014 0.696045C16.1215 0.696045 15.0029 1.83217 15.0029 3.23364C15.0029 4.63512 16.1215 5.77125 17.5014 5.77125Z"
      fill="#1A73E8"
    />
  </SvgIcon>
);
